import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Button from '../../components/Button';
import TextField from '../../components/TextField';
import Snackbar from '../../components/Snackbar';

import useStyles from './styles';
// services
import AuthService from '../../services/authService';

const RecoverPassword = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setMessage('');
    setLoading(true);

    try {
      if (!email) {
        setSeverity('warning');
        setMessage(t('recoverPassword.messages.requiredEmail'));
        return;
      }

      const response = await AuthService.recoverPassword(email);

      if (!response.success) {
        setSeverity('error');
        setMessage(response.errorMessage);
        return;
      }

      setSeverity('success');
      setMessage(t('recoverPassword.messages.success'));
    } catch (e) {
      setSeverity('error');
      setMessage(t('recoverPassword.messages.error'));
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !loading) {
      handleSend();
    }
  };

  return (
    <div className={styles.resetPasswordWrapper}>
      <div className={styles.resetPassword}>
        <img
          className={styles.image}
          src={isLight ? '/logo-lockup-light.png' : '/logo-lockup-dark.png'}
          alt="TCG Scout"
        />
        <Typography variant="h5" className={styles.title} align="center">{t('recoverPassword.title')}</Typography>
        <div>
          <TextField
            id="email"
            type="text"
            label={t('recoverPassword.labels.email')}
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            InputProps={{
              onKeyDown: handleKeyDown,
            }}
          />
        </div>
        <Button
          id="submit-btn"
          backgroundColor="theme-primary-main"
          color="theme-custom-solidButtonText"
          onClick={handleSend}
          text={t('recoverPassword.button')}
          height="40px"
          width="100%"
          disabled={loading}
        />
        <p className={styles.passwordLink}>
          <a href="/login">{t('recoverPassword.links.goBack')}</a>
        </p>
      </div>
      <div>
        <Snackbar
          open={message !== ''}
          message={message}
          severity={severity}
          onClose={() => setMessage('')}
        />
      </div>
    </div>
  );
};

export default RecoverPassword;
